<template>
    <v-container
        class="pt-0"
    >
        <v-row
            justify="center"
        >
            <v-col
                class="pt-0"
                xs="12"
                sm="12"
                md="12"
                lg="10"
                xl="10"
            >
        <!---------------------------------------->
        <!--           Search Filters           -->
        <!---------------------------------------->
                <v-row
                    no-gutters
                >
                    <v-col
                        class="pl-5 pr-3 mb-2"
                    >
                        <v-text-field
                            v-model="keywords"
                            label="Keywords"
                            hide-details
                            prepend-inner-icon="search"
                            height="35"
                            clearable
                        ></v-text-field>
                    </v-col>
                    <v-col
                        v-if="adminView == true"
                        class="shrink mr-3"
                    >
            <!--------------------------------------->
            <!--    Initialize Add Recipe Dialog   -->
            <!--------------------------------------->
                        <v-dialog
                            v-model="addRecipeDialog"
                            fullscreen
                            hide-overlay
                            style="overflow-x: hidden"
                        >
                            <template
                                v-slot:activator="{ on: dialog, attrs}"
                            >
                                <v-col
                                    class="px-3"
                                    cols="12"
                                    xl="3"
                                    lg="4"
                                    md="4"
                                    sm="4"
                                    xs="12"
                                >
                                    <v-tooltip
                                        top
                                    >
                                        <template v-slot:activator="{ on: tooltip}">
                                            <v-btn
                                                fab
                                                small
                                                v-bind="attrs"
                                                v-on="{ ...tooltip, ...dialog}"
                                                color="#74cf74"
                                            >
                                                <v-icon
                                                    color="#ffffff"
                                                    medium
                                                >
                                                    post_add
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            Add Recipe
                                        </span>
                                    </v-tooltip>
                                </v-col>
                            </template>
                <!--------------------------------------->
                <!--   Recipe Pop-up Dialog Contents   -->
                <!--------------------------------------->
                            <v-card>
                                <AddRecipe/>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

        <!---------------------------------------->
        <!--          Advanced Filters          -->
        <!---------------------------------------->
                <!-- <div
                   style="
                        height: 70px;
                        width: 100%;
                    "
                > -->
                    <v-row
                        no-gutters
                    >
                        <v-col>
                            <v-expansion-panels
                                v-model="expandFilters"
                                hover
                                popout
                                focusable
                            >
                                <v-expansion-panel>
                                    <v-expansion-panel-header
                                        height="40"
                                    >
                                        <v-col
                                            class="text-left"
                                        >
                                            Filters
                                        </v-col>
                                        <v-col
                                            v-if="!processing"
                                            class="text-right"
                                        >
                                            results: ({{filteredRecipes.length}})
                                        </v-col>
                                        <v-col
                                            v-else
                                            class="text-right"
                                        >
                                            results:
                                            <v-progress-circular
                                                :size="30"
                                                :width="5"
                                                color="#74cf74"
                                                indeterminate
                                            ></v-progress-circular>
                                        </v-col>
                                    </v-expansion-panel-header>
                                    
                                    <v-expansion-panel-content>
                                        <v-row
                                            no-gutters
                                        >
                                                <!-- diets -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="4"
                                                lg="4"
                                                md="4"
                                                sm="4"
                                                xs="12"
                                            >
                                                <v-row
                                                    no-gutters
                                                >
                                                    Diets
                                                </v-row>
                                                <div>
                                                    <v-row
                                                        v-for="(item,d) in diets"
                                                        :key="d"
                                                        class="ml-5"
                                                        no-gutters
                                                    >
                                                        <v-checkbox
                                                            v-model="diet"
                                                            :label="diets[d].name"
                                                            :value="diets[d].id"
                                                            hide-details
                                                            color="#74cf74"
                                                            height="15"
                                                        >
                                                        </v-checkbox>
                                                    </v-row>
                                                </div>
                                            </v-col>

                                                <!-- meal types -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="4"
                                                lg="4"
                                                md="4"
                                                sm="4"
                                                xs="12"
                                            >
                                                <v-row
                                                    no-gutters
                                                >
                                                    Meal Types
                                                </v-row>
                                                <div>
                                                    <v-row
                                                        v-for="(meal,mt) in mealTypes"
                                                        :key="mt"
                                                        class="ml-5"
                                                        no-gutters
                                                    >
                                                        <v-checkbox
                                                            v-model="mealType"
                                                            :label="mealTypes[mt]"
                                                            :value="mealTypes[mt]"
                                                            hide-details
                                                            color="#74cf74"
                                                            height="15"
                                                        >
                                                        </v-checkbox>
                                                    </v-row>
                                                </div>
                                            </v-col>

                                            <!-- food types -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="4"
                                                lg="4"
                                                md="4"
                                                sm="4"
                                                xs="12"
                                            >
                                                <v-row
                                                    no-gutters
                                                >
                                                    Food Types
                                                </v-row>
                                                <div>
                                                    <v-row
                                                        v-for="(food,ft) in foodTypes"
                                                        :key="ft"
                                                        class="ml-5"
                                                        no-gutters
                                                    >
                                                        <v-checkbox
                                                            v-model="foodType"
                                                            :label="foodTypes[ft].name"
                                                            :value="foodTypes[ft].id"
                                                            hide-details
                                                            color="#74cf74"
                                                            height="15"
                                                        >
                                                        </v-checkbox>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            no-gutters
                                        >
                                            <!-- ingredients to include -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                                sm="6"
                                                xs="12"
                                            >
                                                <v-row
                                                    no-gutters
                                                >
                                                    Ingredients to Include
                                                </v-row>
                                                <v-row
                                                    align="center"
                                                    no-gutters
                                                >
                                                    <v-autocomplete
                                                        v-model="ingredientsToInclude"
                                                        :items="ingredients"
                                                        item-text="name"
                                                        item-value="id"
                                                        hide-details
                                                        multiple
                                                        class="pt-0"
                                                        item-color="#74cf74"
                                                        height="32"
                                                    >
                                                        <template
                                                            v-slot:selection="{ item, index}"
                                                        >
                                                            <v-chip
                                                                v-if="index < 3"
                                                                close
                                                                @click:close="removeIncluded(item)"
                                                            >
                                                                <span>
                                                                    {{ item.name }}
                                                                </span>
                                                            </v-chip>

                                                            <span
                                                                v-if="index === 3"
                                                                class="grey--text caption"
                                                            >
                                                                (+{{ ingredientsToInclude.length - 3 }} more)
                                                            </span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-row>
                                            </v-col>

                                            <!-- ingredients to avoid -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                                sm="6"
                                                xs="12"
                                            >
                                                <v-row
                                                    no-gutters
                                                >
                                                    Ingredients to Avoid
                                                </v-row>
                                                <v-row
                                                    align="center"
                                                    no-gutters
                                                >
                                                    <v-autocomplete
                                                        v-model="ingredientsToExclude"
                                                        :items="ingredients"
                                                        item-text="name"
                                                        item-value="id"
                                                        hide-details
                                                        multiple
                                                        class="pt-0"
                                                        item-color="#74cf74"
                                                        height="32"
                                                    >
                                                        <template
                                                            v-slot:selection="{ item, index }"
                                                        >
                                                            <v-chip
                                                                v-if="index < 3"
                                                                close
                                                                @click:close="removeExcluded(item)"
                                                            >
                                                                <span>
                                                                    {{ item.name }}
                                                                </span>
                                                            </v-chip>
                                                            <span
                                                                v-if="index === 3"
                                                                class="grey--text caption"
                                                            >
                                                                (+{{ ingredientsToExclude.length - 3 }} more)
                                                            </span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                        <v-row
                                            no-gutters
                                        >
                                            <!-- prep time -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                                sm="6"
                                                xs="12"
                                            >
                                                <v-row
                                                    class="mt-3"
                                                    no-gutters
                                                >
                                                    Prep Time (minutes)
                                                </v-row>
                                                <v-row
                                                    no-gutters
                                                >
                                                    <v-autocomplete
                                                        v-model="prepTime"
                                                        :items="prepTimes"
                                                        item-text="label"
                                                        item-value="value"
                                                        hide-details
                                                        class="pt-0"
                                                        height="30"
                                                    ></v-autocomplete>
                                                </v-row>
                                            </v-col>
                                            <!-- recipe source -->
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                                sm="6"
                                                xs="12"
                                            >
                                                <v-row
                                                    class="mt-3"
                                                    no-gutters
                                                >
                                                    Recipe Source
                                                </v-row>
                                                <v-row
                                                    no-gutters
                                                >
                                                    <v-autocomplete
                                                        v-model="recipeSource"
                                                        :items="recipeSources"
                                                        item-text="source_name"
                                                        item-value="id"
                                                        hide-details
                                                        multiple
                                                        class="pt-0"
                                                        item-color="#74cf74"
                                                        height="32"
                                                    >
                                                        <template
                                                            v-slot:selection="{ item, index}"
                                                        >
                                                            <v-chip
                                                                v-if="index < 3"
                                                                close
                                                                @click:close="removeSource(item)"
                                                            >
                                                                <span>
                                                                    {{ item.source_name }}
                                                                </span>
                                                            </v-chip>

                                                            <span
                                                                v-if="index === 3"
                                                                class="grey--text caption"
                                                            >
                                                                (+{{ recipeSource.length - 3 }} more)
                                                            </span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                        <!--           Admin Filters           -->
                                        <v-row
                                            v-if="adminView == true"
                                            no-gutters
                                        >
                                            <v-col
                                                class="px-5 mt-5"
                                                cols="12"
                                            >
                                                <v-row
                                                    class="mt-3"
                                                    no-gutters
                                                >
                                                    Audit Status
                                                </v-row>
                                                <v-row
                                                    no-gutters
                                                >
                                                    <v-select
                                                        v-model="auditFilter"
                                                        :items="['All','Audited','Need to Audit']"
                                                        hide-details
                                                        class="pt-0"
                                                    ></v-select>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                <!-- </div> -->

        <!---------- debugging ---------->
        <!-- <v-row>
            Diet: {{diet}}
            <br>Meal Type: {{mealType}}
            <br>Prep Time: {{prepTime}}
            <br>Food Types: {{foodType}}
            <br>Source: {{recipeSource}}
            <br>Include: {{ingredientsToInclude}}
            <br>Exclude: {{ingredientsToExclude}}
        </v-row> -->


        <!------------------------------------------------------------------------------------>
        <!--                                 Search Results                                 -->
        <!------------------------------------------------------------------------------------>
                <v-row
                    no-gutters
                >
            <!--------------------------------------->
            
            <!--------------------------------------->
                    <v-dialog
                        :key="rerender"
                        v-model="recipeDialog"
                        fullscreen
                        hide-overlay
                        style="overflow-x: hidden"
                    >
                        <template
                            v-if="!adminView"
                            v-slot:activator="{ on }"
                        >
                            <v-col
                                v-for="(recipe,r) in filteredRecipes"
                                :key="r"
                                class="px-3"
                                cols="12"
                                xl="3"
                                lg="4"
                                md="4"
                                sm="4"
                                xs="12"
                            >
                                <v-card
                                    class="my-5 mx-2 pb-1"
                                    @click.prevent="updateSelectedRecipe(recipe.id)"
                                    v-on="on"
                                >

                                    <v-col
                                        class="pa-0"
                                    >
                                        <v-row
                                            no-gutters
                                        >
                                            <v-img
                                                :src="recipe.photo_url"
                                                aspect-ratio="1"
                                            />
                                        </v-row>
                                        <v-row
                                            justify="center"
                                            class="ma-5 text-center text-no-wrap"
                                            no-gutters
                                        >
                                            {{recipe.name}}
                                        </v-row>
                                    </v-col>
                                </v-card>
                            </v-col>
                        </template>
                        <template
                            v-else
                            v-slot:activator="{ on }"
                        >
                            <v-row
                                no-gutters
                                class="mt-5"
                            >
                                <v-col
                                    cols="12"
                                    class="px-5"
                                >
                                    <v-data-table
                                        :headers="[
                                            {
                                            text: 'Name',
                                            align: 'start',
                                            sortable: true,
                                            value: 'name',
                                            },
                                            { text: 'Audited', value: 'auditedDate' },
                                            { text: '% Fat', value: 'percent_calories_from_fat' },
                                            { text: '% Protein', value: 'percent_calories_from_protein' },
                                            { text: '% Carbs', value: 'percent_calories_from_carbs' },
                                        ]"
                                        :items="filteredRecipes"
                                        :items-per-page="30"
                                        :footer-props="{'items-per-page-options':[15,30,50,-1]}"
                                        class="elevation-2"
                                        dense
                                        @click:row="rowClicked"
                                        v-on="on"
                                    ></v-data-table>
                                </v-col>
                            </v-row>
                        </template>
            <!--------------------------------------->
            <!--   Recipe Pop-up Dialog Contents   -->
            <!--------------------------------------->
                        <v-card
                            style="overflow-x: hidden"
                        >
                            <v-row
                                no-gutters
                            >
                                <v-col
                                    v-if="editRecipe == false"
                                >
                                    <Recipe/>
                                </v-col>
                                <v-col
                                    v-else
                                >
                                    <EditRecipe/>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
let moment = require('moment');
import Recipe from '@/components/menu/Recipe.vue'
import AddRecipe from '@/components/menu/AddRecipe.vue'
import EditRecipe from '@/components/menu/EditRecipe.vue'
import _ from 'lodash';

export default {
    mounted() {
        // this.recipes = this.$store.getters['data/recipe'];
        this.filteredRecipes = this.recipes;
        let filteredRecipesLength = this.filteredRecipes.length;

        for (let i=0; i < filteredRecipesLength; i++){
            if (this.filteredRecipes[i].audited == null){
                this.filteredRecipes[i].auditedDate = null;
            } else {
                this.filteredRecipes[i].auditedDate = moment(this.filteredRecipes[i].audited).format('M/D/YYYY')
            }
        }
    },

    // beforeCreate() {
        // let account = this.$store.getters['data/account'];
        // let diets = this.$store.getters['data/diets'];
        // let max = diets.length;

    //     for (let d = 0; d < max; d++){
    //         if (diets[d].id == account.diet_lookup) {
    //             this.diet = [diets[d].id];
    //             d = max;
    //         }
    //     }

    //     console.log('beforeCreate diet value:',this.diet);
    // },

    components: {
        Recipe,
        AddRecipe,
        EditRecipe
    },

    data: () => ({
        moment: moment,
        keywords: null,
        diet: [],
        //dietFilter: [],
        //dietFilterChanges: 0,
        mealType: [],
        mealTypes: ['breakfast','lunch','dinner','snack'],
        foodType: [],
        expandFilters: false,
        ingredientsToInclude: [],
        ingredientsToExclude: [],
        recipeSource: [],
        prepTime: [],
        filteredRecipes: [],
        prepTimes: [
            {
                label: 'any',
                value: 0
            },{
                label: 'under 5',
                value: 5
            },{
                label: 'under 15',
                value: 15
            },{
                label: 'under 30',
                value: 30
            },{
                label: 'under 45',
                value: 45
            },{
                label: 'under 60',
                value: 60
            }
        ],
        auditFilter: 'All',

    }),

    watch: {
        keywords() {
            this.debouncedApplyFilters();
        },
        diet() {
            this.debouncedApplyFilters();
        },
        mealType() {
            this.debouncedApplyFilters();
        },
        foodType() {
            this.debouncedApplyFilters();
        },
        prepTime() {
            this.debouncedApplyFilters();
        },
        recipeSource() {
            this.debouncedApplyFilters();
        },
        ingredientsToInclude() {
            this.debouncedApplyFilters();
        },
        ingredientsToExclude() {
            this.debouncedApplyFilters();
        },
        auditFilter() {
            this.debouncedApplyFilters();
        }
    },


    methods: {
        // closeRecipe() {
        //     this.recipeDialog = false;
        //     this.forceRerender();   //need to re-render recipe list when closing a recipe so the chart on the recipe works (not sure why..)
        //     // this.$store.dispatch('menu/updateRecipeSize', null);
        //     // this.$store.dispatch('menu/updateRecipeSizeUnits', null);
        // },
        removeIncluded(item) {
            this.ingredientsToInclude.splice(this.ingredientsToInclude.indexOf(item), 1)
            this.ingredientsToInclude = [...this.ingredientsToInclude]
        },
        removeExcluded(item) {
            this.ingredientsToExclude.splice(this.ingredientsToExclude.indexOf(item), 1)
            this.ingredientsToExclude = [...this.ingredientsToExclude]
        },
        removeSource(item) {
            this.recipeSource.splice(this.recipeSource.indexOf(item), 1)
            this.recipeSource = [...this.recipeSource]
        },
        updateSelectedRecipe(ID) {
            this.$store.dispatch('data/updateSelectedRecipeID',ID);
        },
        debouncedApplyFilters:_.debounce(function() {
            this.applyFilters();
            },400
        ),
        applyFilters() {
            this.updateFilters();
            this.forceRerender();
        },
        updateFilters() {
            let result = [];
            let str = null;
            let include = 0;
            let includedIngredientsLength = 0;
            let includedKeywordsLength = 0;
            let keywordsArray = [];
            let dietLength = this.diet.length;
            let mealTypeLength = this.mealType.length;
            let foodTypeLength = this.foodType.length;
            let prepTimeLength = this.prepTime.length;
            let recipeSourceLength = this.recipeSource.length;
            let ingredientsToIncludeLength = this.ingredientsToInclude.length;
            let ingredientsToExcludeLength = this.ingredientsToExclude.length;
            let recipesLength = this.recipes.length;
            let keywordsLength = 0;
            let drjLength = this.dietRecipeJunction.length;
            let rftjLength = this.recipeFoodTypeJunction.length;
            let rijLength = this.recipeIngredientJunction.length;
            let filteredRecipesLength = 0;

            if (this.keywords == null || this.keywords == '') {
                keywordsLength = 0;
            } else {
                for (let k = 0; k < this.keywords.split(" ").length; k++) {
                    keywordsArray.push(this.keywords.split(" ")[k]);
                }
                keywordsLength = keywordsArray.length;
            }

            for (let r=0; r < recipesLength; r++){
                //reset include to 0, only add recipe to result if include passes all filters
                include = 0;
                includedIngredientsLength = 0;
                includedKeywordsLength = 0;
                str = null;

                //-----        filter for keywords        -----//
                if (keywordsLength == 0) {
                    include += 1;
                } else {
                    for (let k=0; k < keywordsLength; k++) {
                        if (this.recipes[r].name.toLowerCase().includes(keywordsArray[k].toLowerCase())) {
                            includedKeywordsLength += 1;
                        }
                    }
                    if (includedKeywordsLength >= keywordsLength){
                        include += 1
                    }
                }

                //-----         filter for diets         -----//
                if (dietLength == 0){
                    include += 1;
                } else {
                    for (let d=0; d < dietLength; d++) {
                        for (let drj=0; drj < drjLength; drj++) {
                            if (
                                this.dietRecipeJunction[drj].diet_lookup == this.diet[d]
                                && this.dietRecipeJunction[drj].recipe_lookup == this.recipes[r].id
                            ){
                                include += 1;
                                drj = drjLength;
                                d = dietLength;
                            }
                        }
                    }
                }

                //-----       filter for meal type       -----//
                if (mealTypeLength == 0) {
                    include += 1;
                } else {
                    for (let mt=0; mt < mealTypeLength; mt++) {
                        str = this.recipes[r].meal_type
                        if (str.includes(this.mealType[mt])) {
                            include += 1;
                            mt = mealTypeLength;
                        }
                    }
                }

                //-----       filter for food type       -----//
                if (foodTypeLength == 0) {
                    include += 1;
                } else {
                    for (let ft=0; ft < foodTypeLength; ft++) {
                        for (let rftj=0; rftj < rftjLength; rftj++) {
                            if (
                                this.recipeFoodTypeJunction[rftj].food_type_lookup == this.foodType[ft]
                                && this.recipeFoodTypeJunction[rftj].recipe_lookup == this.recipes[r].id
                            ){
                                include += 1;
                                ft = foodTypeLength;
                                rftj = rftjLength;
                            }
                        }
                    }
                }

                //-----       filter for prep time       -----//
                if (prepTimeLength == 0 || this.prepTime == 0) {
                    include += 1;
                } else { 
                    if (this.recipes[r].prep_time_min <= this.prepTime) {
                        include += 1;
                    }
                }

                //-----     filter for recipe source     -----//
                if (recipeSourceLength == 0) {
                    include += 1;   
                } else {
                    for (let rs=0; rs < recipeSourceLength; rs ++) {
                        if (this.recipes[r].recipe_source_lookup == this.recipeSource[rs]) {
                            include += 1;
                            rs = recipeSourceLength;
                        }
                    }
                }

                //----- filter for ingredients - both ways -----//
                if (ingredientsToIncludeLength == 0 && ingredientsToExcludeLength == 0) {
                    include += 1;
                } else {
                    // loop through recipe ingredient junctions in the system
                    for (let rij=0; rij < rijLength; rij++) {
                        // check if recipe ingredient junction is for this recipe
                        if (this.recipeIngredientJunction[rij].recipe_lookup == this.recipes[r].id) {
                            // loop through the ingredients to include and add any matches to the count
                            for (let inc=0; inc < ingredientsToIncludeLength; inc++) {
                                if (this.recipeIngredientJunction[rij].ingredient_lookup == this.ingredientsToInclude[inc]) {
                                    includedIngredientsLength += 1
                                }
                            }
                            // also loop through the ingredients to exclude and if match is found, exclude recipe and exit loop
                            for (let exc=0; exc < ingredientsToExcludeLength; exc++) {
                                if (this.recipeIngredientJunction[rij].ingredient_lookup == this.ingredientsToExclude[exc]) {
                                    include = 0;
                                    exc = ingredientsToExcludeLength;
                                    rij = rijLength;
                                }
                            }
                        }
                    }
                    // after looping through all recipe_ingredient_junctions see if the count of junctions passed >= ingredients to include length
                    if (includedIngredientsLength >= ingredientsToIncludeLength) {
                        include += 1;
                    }  
                }


                //-----       filter for audit type       -----//
                if (this.auditFilter == 'All'
                    || (this.auditFilter == 'Audited' && this.recipes[r].audited != null)
                    || (this.auditFilter == 'Need to Audit' && this.recipes[r].audited == null)
                ) {
                    include += 1;
                }


                //     if all filters pass, add to result     //
                if (include == 8) {
                    result.push(this.recipes[r])
                }
            }

            //--------------------------------------------//
            //               return results               //
            //--------------------------------------------//
            this.filteredRecipes = result;

            filteredRecipesLength = this.filteredRecipes.length;
            for (let i=0; i < filteredRecipesLength; i++){
                if (this.filteredRecipes[i].audited == null){
                    this.filteredRecipes[i].auditedDate = null;
                } else {
                    this.filteredRecipes[i].auditedDate = moment(this.filteredRecipes[i].audited).format('M/D/YYYY')
                }
            }

        },
        forceRerender() {
            this.rerender += 1;
            // this.recipes = this.$store.getters['data/recipe'];
        },
        rowClicked(value) {
            this.updateSelectedRecipe(value.id);
            this.recipeDialog = true;
        }

    },

    computed: {
        adminView() {
            return this.$store.getters['data/adminView'];
        },
        diets() {
            return this.$store.getters['data/diets'];
        },
        dietRecipeJunction() {
            return this.$store.getters['data/dietRecipeJunction'];
        },
        foodTypes() {
            return this.$store.getters['data/foodTypes'];
        },
        recipeFoodTypeJunction() {
            return this.$store.getters['data/recipeFoodTypeJunction'];
        },
        ingredients() {
            return this.$store.getters['data/ingredient'];
        },
        recipeSources() {
            return this.$store.getters['data/recipeSource'];
        },
        recipes() {
            return this.$store.getters['data/recipe'];
        },
        selectedRecipeID() {
            return this.$store.getters['data/selectedRecipeID'];
        },
        selectedRecipe() {
            let response = null
            for (let i=0; i < this.recipes.length; i++) {
                if (this.recipes[i].id == this.selectedRecipeID) {
                    response = this.recipes[i];
                }
            }
            return response;
        },
        recipeIngredientJunction() {
            return this.$store.getters['data/recipeIngredientJunction'];
        },
        addRecipeDialog: {
            get(){
                return this.$store.getters['data/addRecipeDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateAddRecipeDialog',value);
            }
        },
        recipeDialog: {
            get(){
                return this.$store.getters['data/recipeDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateRecipeDialog',value);
            }
        },
        rerender: {
            get(){
                return this.$store.getters['data/rerender'];
            },
            set(value) {
                this.$store.dispatch('data/forceRerender',value);
            }
        },
        processing: {
            get() {
                return this.$store.getters['data/processing'];
            },
            set(value) {
                this.$store.dispatch('data/updateProcessing',value);
            }
        },
        editRecipe: {
            get(){
                return this.$store.getters['data/editRecipe'];
            },
            set(value) {
                this.$store.dispatch('data/updateEditRecipe',value);
            }
        }

        // thisRecipeIngredients() {
        //     let response = [];
        //     let entry = {};

        //     for (let i=0; i < this.recipeIngredientJunction.length; i++) {
        //         if(this.recipeIngredientJunction[i].recipe_lookup == this.selectedRecipeID) {
        //             for (let j=0; j < this.ingredients.length; j++) {
        //                 if (this.ingredients[j].id == this.recipeIngredientJunction[i].ingredient_lookup) {
        //                     entry = this.recipeIngredientJunction[i];
        //                     entry.name = this.ingredients[j].name;
        //                     entry.grocery_store_section = this.ingredients[j].grocery_store_section;
        //                     response.push(entry);
        //                 }
        //             }
        //         }
        //     }
        //     return response.sort((a,b) => (a.grocery_store_section > b.grocery_store_section) ? 1 : -1);
        // },

    }
};
</script>
